import type { Component, ComponentOptionsMixin } from 'vue';
import { assign } from 'lodash';

import type { AlertOptions } from '../component/modal/AlertModal.vue'
import AlertModal from '../component/modal/AlertModal.vue'

import { modal } from './modal'
import type { OverlayResult } from '../plugin';

declare module '@vue/runtime-core' {
    interface ComponentCustomProperties {
        $alert: AlertService
    }
}

export class AlertService {

    comp: Component
    $i18n: any
    $modal: typeof modal

    constructor(comp){

        this.comp = comp;

        this.$i18n = this.comp['$i18n'];
        this.$modal = modal.bind(comp);
    }

    alert(title: string, options?: Partial<AlertOptions>){

        return this.show(options, {
            positiveButton: this.$i18n.t('core.general.ok'),
            title
        });
    }

    confirm(title: string, spinner?: boolean, options?: Partial<AlertOptions>){

        return this.show(options, {
            title,
            cancelButton: true,
            negativeButton: this.$i18n.t('core.general.confirm'),
            spinnerResult: spinner ? false : undefined

        }).then((result) => {

            // Switch result
            if(result.result === false){
                result.result = true;
            }
            else if(result.result === true){
                result.result = false;
            }

            return result;
        });
    }

    delete(title: string, spinner: boolean=true, options?: Partial<AlertOptions>){

        return this.confirm(title, spinner, {

            negativeButton: this.$i18n.t('core.general.delete'),
            negativeButtonIcon: 'bx bx-trash',

            ...options
        });
    }

    confirmDelete(title: string, spinner: boolean=true, options?: Partial<AlertOptions>){

        return this.delete(title, spinner, options);
    }

    show(options: Partial<AlertOptions>, defaultOptions?: AlertOptions): Promise<OverlayResult> {

        const allOptions = defaultOptions ? assign(defaultOptions, options) : options;

        // @ts-ignore
        return this.$modal(AlertModal, allOptions);
    }
}

export const alertMixin: ComponentOptionsMixin = {

    computed: {

        $alert(): AlertService {

            if(!this._alertService){
                this._alertService = new AlertService(this);
            }

            return this._alertService;
        }
    }
}

export default alertMixin;

